export default function (app) {
	app.config(['$provide', 'uibDatepickerPopupConfig', 'uibDatepickerConfig', 'frameContext', 'COMMON_CONSTS',
		function ($provide, uibDatepickerPopupConfig, uibDatepickerConfig, frameContext, constants) {

			if (frameContext.user_profile) {
				moment.locale(frameContext.user_profile.language.toLowerCase());
				uibDatepickerConfig.formatDay = constants.DATEFORMAT.formatDay;

				$provide.constant(
					'uibDatepickerPopupConfig',
					angular.extend(
						uibDatepickerPopupConfig,
						{
							datepickerPopup: constants.DATEFORMAT.languages[moment.locale()].ui,
							altInputFormats: constants.DATEFORMAT.alt_input_formats.ui
						}
					)
				);
			}
		}]);

};
